export let initialState = {
  header: false,
  message: false,
  negative: false
}

export const updateMessage =
  (app_message) =>
  ({ message = false, header = false, negative = false }) => {
    app_message.setState({ header, message, negative })
  }
